module.exports = __webpack_public_path__ + "img/entrega.439d43ad.png";